import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TRANSLOCO_TRANSPILER,
  TranslocoTranspiler,
  TRANSLOCO_MISSING_HANDLER,
  TRANSLOCO_INTERCEPTOR,
  TRANSLOCO_FALLBACK_STRATEGY,
} from '@ngneat/transloco';
import { Injectable, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CustomMissingHandler } from '../services/common/custom-missing-handler.service';
import { CustomTranslocoInterceptor } from '../interceptors/custom-transloco.interceptor';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@Injectable({ providedIn: 'root' })
export class CustomTranspiler implements TranslocoTranspiler {
  transpile(value: string): string {
    return value;
  }
}

export const translocoProviders: EnvironmentProviders = makeEnvironmentProviders([
  {
    provide: TRANSLOCO_CONFIG,
    useValue: translocoConfig({
      availableLangs: ['en', 'es'],
      defaultLang: 'es',
      fallbackLang: 'es',
      reRenderOnLangChange: true,
      prodMode: environment.production,
    }),
  },
  { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
  { provide: TRANSLOCO_TRANSPILER, useClass: CustomTranspiler },
  { provide: TRANSLOCO_MISSING_HANDLER, useClass: CustomMissingHandler },
  {
    provide: TRANSLOCO_FALLBACK_STRATEGY,
    useValue: 'ONLY_FALLBACK',
  },
  {
    provide: TRANSLOCO_INTERCEPTOR,
    useClass: CustomTranslocoInterceptor,
  },
]);